<script setup>
const props = defineProps({
    title: { type: String, required: true }
});
</script>

<template>
    <h1 class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 md:mb-6">{{ props.title }}</h1>
</template>